import React from 'react';
import { useAccountName } from 'App/helpers/accountNames';
import { getClientCardHref } from 'App/helpers/clientCardNavigation';

export const AccountLink = ({ id, name }: { id: number; name: string }) => (
	<a href={getClientCardHref(id)} onClick={e => e.stopPropagation()}>
		{name}
	</a>
);

/** An Account field's value: the company's current name linking to its card, or nothing once the company is gone. */
const AccountName = ({ value }: { value?: string | number | null }) => {
	const name = useAccountName(value);
	return name ? <AccountLink id={Number(value)} name={name} /> : null;
};

export default AccountName;
